
import { Vue, Component } from 'vue-property-decorator';
import { AvailableLoan } from '@/interfaces/loan';
import CollectionAlert from '@/components/Loans/Collections/CollectionAlert.vue';

@Component({ components: { CollectionAlert } })
export default class CollectionAlerts extends Vue {
  get activeLoanNumber(): string {
    return this.$store.getters['User/activeLoanNumber'];
  }

  get loansInCollection(): AvailableLoan[] {
    return this.$store.getters['User/loansInCollection']
      .sort((a: AvailableLoan, b: AvailableLoan) => {
        if (a.loan_number === this.activeLoanNumber) {
          return -1;
        }
        if (b.loan_number === this.activeLoanNumber) {
          return 1;
        }

        return 0;
      });
  }
}
